import { computed, makeObservable } from 'mobx'
import Job from 'jobs/Job'
import JobStore from 'jobs/JobStore'
import Member from 'iam/models/Member'
import { AlertFactory } from 'alerts/Alert'
import {
  FinalReturnAmountsDialogViewModel,
  returnAmountsToYearInputs,
} from '../FinalReturnAmountsDialog/FinalReturnAmountsDialogViewModel'

/**
 * Details-view card showing the per-tax-year final return amounts recorded
 * when the Pro filed the return, with an edit affordance for the assigned Pro
 * and workspace admins.
 */
export class FinalReturnAmountsCardViewModel {
  constructor(
    private job: Job,
    private jobStore: JobStore,
    newAlert: AlertFactory,
    private getMember: () => Member,
  ) {
    makeObservable(this)

    this.dialogVM = new FinalReturnAmountsDialogViewModel(
      this.jobStore,
      this.job,
      newAlert,
      this.onSaved,
      () => returnAmountsToYearInputs(this.job.returnAmounts),
    )
  }

  readonly dialogVM: FinalReturnAmountsDialogViewModel

  /**
   * The card is hidden entirely until amounts exist — most jobs never reach a
   * final return, and an empty card on all of them is noise.
   */
  @computed
  get canView() {
    return this.job.hasReturnAmounts
  }

  @computed
  get years() {
    return this.job.returnAmounts
  }

  @computed
  get canEdit() {
    return (
      this.job.isProviderCollaborator ||
      this.getMember().hasPermission('ADMIN_JOB_UPDATE')
    )
  }

  /**
   * Realtime job-updated events carry only Last Activity, so a save has to
   * refetch the job for the card to reflect it.
   */
  onSaved = async () => {
    await this.jobStore.refreshJob(this.job.id)
  }

  edit = () => {
    this.dialogVM.show()
  }
}
